import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { customerService } from '../services/customerService';

export function useProductSearch(query: string) {
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query), 300);
    return () => clearTimeout(timer);
  }, [query]);

  const { data: products = [], isLoading } = useQuery({
    queryKey: ['product-search', debouncedQuery],
    queryFn: () => customerService.searchProducts(debouncedQuery),
    enabled: debouncedQuery.trim().length >= 2,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });

  return {
    products,
    isLoading: isLoading && debouncedQuery.trim().length >= 2,
    hasQuery: debouncedQuery.trim().length >= 2,
  };
}
